/**
 * Audio System Constants
 * Shared configuration values for audio processing
 */

/**
 * ANTI-POP Configuration
 *
 * When starting playback, synths can produce an audible click or pop if their
 * volume transitions instantly from silence to the target level. This is caused
 * by sudden discontinuities in the audio waveform.
 *
 * To prevent this:
 * 1. Set synth volume to -Infinity (complete silence) before starting Transport
 * 2. Start the Transport
 * 3. Ramp synth volume from -Infinity to 0dB over a short duration (20ms)
 *
 * This happens on EVERY play (first, second, etc.), ensuring consistent behavior.
 * No special handling is needed on stop - synth envelopes handle decay naturally.
 *
 * This applies to both Tone.js synths and WASM synths, which both implement
 * the same volume interface:
 *   - volume.value: number (in dB)
 *   - volume.rampTo(targetDb: number, rampTime: number, startTime?: number): void
 */

/**
 * Duration of the fade-in ramp when starting playback (in seconds)
 * 20ms is short enough to be imperceptible but long enough to prevent pops
 */
export const ANTI_POP_FADE_IN_TIME = 0.02;

/**
 * Initial volume level before fade-in (in dB)
 * -Infinity represents complete silence
 */
export const ANTI_POP_INITIAL_VOLUME = -Infinity;

/**
 * Target volume level after fade-in (in dB)
 * 0dB represents unity gain (no attenuation)
 */
export const ANTI_POP_TARGET_VOLUME = 0;
